<div class="items__select-area">
    <div
        class="wrapper-items__select-area"
        #productItem
        [tabindex]="tabIndex"
        (click)="selectItem()"
        (keydown.enter)="selectItem()"
        (keydown.space)="selectItem()"
        (keydown.arrowleft)="movedLeft()"
        (keydown.arrowright)="movedRight()"
        (keydown.arrowup)="movedLeft()"
        (keydown.arrowdown)="movedRight()"
        (focus)="focused()"
        (blur)="blurred()"
        role="radio"
        attr.aria-checked="{{ selected }}">
        <div class="btn btn--big-selection" [ngClass]="{ selected: selected }">
            <div class="circle-icon">
                <span class="icon icon-progress-check hidden"></span>
            </div>
            <div class="btn--big-selection__top-wrapper">
                <div class="btn--big-selection__top" *ngIf="!overrideNames">
                    {{ item | translateObjectField: 'name' : lang }}
                </div>

                <div class="btn--big-selection__top" *ngIf="overrideNames">
                    {{ item | translateObjectField: 'group_name' : lang }}
                </div>
            </div>
            <div class="btn--big-selection__bottom-wrapper">
                <div class="btn--big-selection__bottom" *ngIf="(price$ | async)?.price">
                    <div class="btn--big-selection__bottom__price">
                        <ng-container
                            *ngIf="
                                item | productHasProperty: ProductPropertiesType.DynamicLength;
                                else defaultPriceTmpl
                            ">
                            <span class="notranslate">
                                {{ (price$ | async)?.price | moneyFormat }}
                            </span>
                        </ng-container>
                        <ng-template #defaultPriceTmpl>
                            <span class="notranslate">
                                {{ (price$ | async)?.price | moneyFormat: (totalDays$ | async) }}
                            </span>
                        </ng-template>

                        {{ appStartupService.getCurrency() | translate }}
                    </div>
                </div>

                <div
                    class="btn--big-selection__bottom"
                    *ngIf="
                        !(price$ | async)?.price &&
                        item.price &&
                        !(item | productHasProperty: ProductPropertiesType.DynamicLength)
                    ">
                    <div class="btn--big-selection__bottom__price">
                        <span class="notranslate">
                            {{ item.price | moneyFormat: (totalDays$ | async) }}
                        </span>
                        {{ 'CURRENCY' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
